module.exports = __webpack_public_path__ + "img/9791185093086.c8f22e94.jpg";